import { generatePath } from 'react-router-dom';
import { RoutePaths } from 'src/stores/RouterStore/RoutePaths';

type Links = {
    list?: () => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemDetails?: (id?: string | number) => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemEdit?: (id?: string | number) => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    process?: (id?: string | number) => string;

    create?: () => string;

    index?: () => string;
};

export type EntityNames = 'index' | 'loanApplications';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const EntityLinks: { [key in EntityNames]: Links } = {
    index: {
        index: () => RoutePaths.index,
    },
    loanApplications: {
        list: () => RoutePaths.loanApplications,
        itemDetails: (id) => {
            return generatePath(RoutePaths.loanApplicationDetails, {
                id: String(id),
            });
        },
        create: () => RoutePaths.loanApplicationsCreate,
    },
};
